import { 
    GET_BUS_OPERATORS ,
    INSERT_BUS_OPERATOR,
    DELETE_BUS_OPERATOR,
    UPDATE_BUS_OPERATOR,
    CREATE_OPERATOR_MAPPING
} from './action-types';
import { 
    GET_BUS_OPERATORS_URL ,
    INSERT_BUS_OPERATOR_URL,
    DELETE_BUS_OPERATOR_URL,
    UPDATE_BUS_OPERATOR_URL,
    CREATE_OPERATOR_MAPPING_URL
  } from "../utils/api-url";
import { postCall } from "../utils/network.util";
import { API_B2B_ADMIN_BASE_URL, APP_ENV, API_NORTH_ADMIN_URL } from './../app.config';

export const getBusOperators= () => {
    return {
        type: GET_BUS_OPERATORS,
        payload: {
            url: GET_BUS_OPERATORS_URL,
            api: postCall,
            apiPayload:{
                operatorCode:global.operator_code
            }
        }
    }
}

export const createBusOperator= (travelInfo,multiCallObject={region:'south', isAgentsRequired:true},onSuccess) => {

    let url = multiCallObject.region === 'south' ? API_B2B_ADMIN_BASE_URL : API_NORTH_ADMIN_URL;
    url+=INSERT_BUS_OPERATOR_URL;

    return {
        type: INSERT_BUS_OPERATOR,
        payload: {
            url: url,
            api: postCall,
            apiPayload:{
                travelInfo:{
                    ...travelInfo,
                    milesPercent:0,
                    accessCode:'',
                    userName:travelInfo.name,
                    encryptedPassword:null,
                    isAgentsRequired: multiCallObject.isAgentsRequired
                }
            },
            onSuccess:onSuccess
        }
    }
}

export const updateBusOperator= (travelInfo,operatorCode,multiCallObject={region:'south', isAgentsRequired:true} ,onSuccess) => {

    let url = multiCallObject.region === 'south' ? API_B2B_ADMIN_BASE_URL : API_NORTH_ADMIN_URL;
    url+=UPDATE_BUS_OPERATOR_URL;

    return {
        type:UPDATE_BUS_OPERATOR,
        payload: {
            url: url,
            api: postCall,
            apiPayload:{
                travelInfo:{
                    ...travelInfo,
                    milesPercent:0,
                    accessCode:'',
                    userName:travelInfo.name,
                    encryptedPassword:null,
                    isAgentsRequired: multiCallObject.isAgentsRequired
                },
                operatorCode:operatorCode
            },
            onSuccess:onSuccess
        }
    }
}

export const deleteBusOperator= (operatorCode,multiCallObject={region:'south'},onSuccess) => {

    let url = multiCallObject.region === 'south' ? API_B2B_ADMIN_BASE_URL : API_NORTH_ADMIN_URL;
    url+=DELETE_BUS_OPERATOR_URL;

    return {
        type: DELETE_BUS_OPERATOR,
        payload: {
            url: url,
            api: postCall,
            apiPayload:{
                operatorCode:operatorCode
            },
            onSuccess:onSuccess
        }
    }
}

export const createOperatorMappingAction = (operatorCode,region) => {
    return {
        type: CREATE_OPERATOR_MAPPING,
        payload: {
            url: CREATE_OPERATOR_MAPPING_URL,
            api: postCall,
            apiPayload: {
                operatorCode: operatorCode,
                operatorEnv: APP_ENV,
                region: region
            }
        }
    }
}
